var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestByVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 9C21.2552 12.3044 18.7502 15 16.0002 15C13.2502 15 10.7408 12.305 10.5002 9C10.2502 5.5625 12.6877 3 16.0002 3C19.3127 3 21.7502 5.625 21.5002 9Z",
    fill: "#F6F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19C10.5627 19 5.0439 22 4.02265 27.6625C3.89953 28.345 4.28578 29 5.00015 29H27.0002C27.7152 29 28.1014 28.345 27.9783 27.6625C26.9564 22 21.4377 19 16.0002 19Z",
    fill: "#F6F8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 5C24.6667 6.16667 26.3 9.2 23.5 12M26 3C28.5 5 29.5 11 26 14",
    stroke: "#F6F8FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestByVoice);
export default __webpack_public_path__ + "static/media/guest-by-voice.d37dcc1157d8dab9e2cbada19e9ea92a.svg";
export { ForwardRef as ReactComponent };